import React, { Suspense, useState } from 'react';
// func
import { scrollDisable, scrollEnable } from '../../../func/scroll';

const SendImagesModal = React.lazy(() => import(/* webpackChunkName: "direct-uploader" */ './send-images-modal'));

export default function FormSendImages({ memberId, sender }) {
  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = () => {
    setOpenModal(true);
    scrollDisable();
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    scrollEnable();
  };

  return (
    <>
      <div className="f-grow-1 align-items-center justify-content-center" onClick={handleOpenModal}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="#cccccc" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.0034 8.56641L5.41956 15.3766C5.24073 15.6424 5.43112 16 5.7514 16H18.35C18.648 16 18.8414 15.6858 18.7071 15.4197L16.5333 11.1136C16.4177 10.8846 16.1194 10.8221 15.9216 10.9854L13.463 13.0146C13.2652 13.1779 12.9669 13.1154 12.8513 12.8864L10.6923 8.6095C10.5546 8.33663 10.1741 8.31283 10.0034 8.56641Z" />
          <path d="M16 7C16 6.66863 16.2686 6.4 16.6 6.4H21.4C21.7314 6.4 22 6.66863 22 7C22 7.33137 21.7314 7.6 21.4 7.6H16.6C16.2686 7.6 16 7.33137 16 7Z" />
          <path d="M19 10C18.6686 10 18.4 9.73137 18.4 9.4V4.6C18.4 4.26863 18.6686 4 19 4C19.3314 4 19.6 4.26863 19.6 4.6V9.4C19.6 9.73137 19.3314 10 19 10Z" />
          <path d="M17 2.75C17 2.33579 16.6642 2 16.25 2H4C1.79089 2 0 3.79086 0 6V18C0 20.2091 1.79089 22 4 22H20C22.2091 22 24 20.2091 24 18V9.75C24 9.33579 23.6642 9 23.25 9C22.8358 9 22.5 9.33579 22.5 9.75V18C22.5 19.3807 21.3807 20.5 20 20.5H4C2.61926 20.5 1.5 19.3807 1.5 18V6C1.5 4.61929 2.61926 3.5 4 3.5H16.25C16.6642 3.5 17 3.16421 17 2.75Z" />
        </svg>
      </div>

      {openModal && (
        <Suspense fallback={null}>
          <SendImagesModal closeModal={handleCloseModal} memberId={memberId} sender={sender} />
        </Suspense>
      )}
    </>
  );
}
